/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Attribute, ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'ngf-pill,ngf-pill[large]',
    templateUrl: './pill.component.html',
    styleUrls: ['./pill.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PillComponent {
  @Input()
  removable = false;

  @Input()
  ariaLabel?: string;

  @Output()
  remove = new EventEmitter<MouseEvent>();

  constructor(@Attribute('primary') primary: any,
              @Attribute('success') success: any,
              @Attribute('danger') danger: any,
              @Attribute('warning') warning: any,
              @Attribute('filled') filled: any,
              @Attribute('archive') archive: any,) { }

  handleRemove($event: MouseEvent) {
    this.remove.emit($event);
  }

}
